module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3733f47ed2f589eca8b02d1f34d43ee4.png";